import axios from "../../api";

export const getAuthors = async () => {
  const res = await axios.get("/tactics/authors");
  return res.data;
};
